import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Tag, PhotoFrame } from "./Shared";
import { fmtDate } from "../lib/api";

export default function ProjectCard({ p, index = 0 }) {
  return (
    <Link
      to={`/projects/${p.id}`}
      className="card-line group relative flex flex-col"
      data-testid={`project-card-${p.id || index}`}
    >
      <div className="relative h-56 overflow-hidden">
        <PhotoFrame src={p.cover_image} alt={p.title} label={p.title} className="h-full w-full" imgClassName="transition-transform duration-700 group-hover:scale-105" />
        <div className="absolute left-4 top-4 z-10">
          <Tag tone="ember">{p.category}</Tag>
        </div>
      </div>
      <div className="flex flex-1 flex-col p-6">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-silver-muted">{fmtDate(p.date)}</p>
        <h3 className="mt-3 font-display text-2xl font-semibold text-silver transition-colors group-hover:text-white">{p.title}</h3>
        <p className="mt-3 flex-1 text-sm leading-relaxed text-silver-muted">{p.description}</p>
        <span className="mt-6 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-silver-dim transition-all duration-300 group-hover:gap-3.5 group-hover:text-white" data-testid="project-card-view-btn">
          View Project <ArrowUpRight size={14} className="text-ember" />
        </span>
      </div>
    </Link>
  );
}
